var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopbarIconRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.074,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#d286ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#8a19ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#6e14a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#480971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#6e14a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#974dc4",
    stopOpacity: 0.635
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16067",
    "data-name": "Group 16067",
    transform: "translate(2974 -3715)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "refresh",
    transform: "translate(-3312 3693)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18514",
    "data-name": "Path 18514",
    d: "M16,0A16,16,0,1,1,0,16,16,16,0,0,1,16,0Z",
    transform: "translate(338 22)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18514_-_Outline",
    "data-name": "Path 18514 - Outline",
    d: "M16,1A15,15,0,0,0,5.393,26.607,15,15,0,1,0,26.607,5.393,14.9,14.9,0,0,0,16,1m0-1A16,16,0,1,1,0,16,16,16,0,0,1,16,0Z",
    transform: "translate(338 22)",
    fill: "#ffd055"
  }), /*#__PURE__*/React.createElement("g", {
    id: "refresh-2",
    "data-name": "refresh",
    transform: "translate(346.036 17.406)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M15.259,20.515h-.974A7.075,7.075,0,0,0,2.191,15.483,7.066,7.066,0,0,0,0,20.515H0v.045H0A7.124,7.124,0,0,0,7.08,27.676a7.033,7.033,0,0,0,5.01-2.092L10.5,24.052a4.867,4.867,0,1,1-6.721-7.04,4.857,4.857,0,0,1,8.288,3.5v.008H11.1c-.6,0-.84.4-.542.885l2.077,2.054c.475.475.612.471,1.084,0L15.8,21.4C16.1,20.914,15.855,20.515,15.259,20.515Z",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopbarIconRefresh);
export default __webpack_public_path__ + "static/media/topbar-icon-refresh.86c8e12d34c0eb96b64ea0fb94c47522.svg";
export { ForwardRef as ReactComponent };